module.exports = __webpack_public_path__ + "static/assets/e372ffe2f2bd1a9148225dbfc1196d73.svg";